<template>
  <Select
    :label="$t('code')"
    v-model="code"
    :items="countries"
    item-text="name_code"
    item-value="dial_code"
    hide-details
    required
    @change="$emit('input', code); $emit('change', code)"
    :style="`width: ${width};`"
  />
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'
import countries from '@/resources/json/countries.json'
import Select from '@/components/ui/Select.vue'

export default {
  components: {
    Select
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
  },
  computed: {
    ...mapState({
      customer: state => state.storage?.room?.customer ?? {},
    })
  },
  watch: {
    customer: {
      immediate: true,
      handler() {
        this.updateCode()
      }
    }
  },
  data() {
    return {
      countries: countries,
      code: null
    }
  },
  methods: {
    getCode() {
      const iso = this.$cityMap.country.iso
      const country = this.countries.find((item) => item.code === iso)
      return country ? country.dial_code : this.countries[0].dial_code
    },
    updateCode() {
      this.code = this.customer?.countryCode ?? this.getCode()
      this.$emit('input', this.code)
    }
  },
  mounted() {
    this.countries.map(country => {
      country.name_code = `${country.name} (${country.dial_code})`
    })

    this.countries.sort((a, b) => {
      return (a.name > b.name) ? 1 : (a.name < b.name) ? -1 : 0
    })

    this.updateCode()
  }
}
</script>
